<template>
    <div class="card card-default">
        <div class="card-header">
            <div class="float-left">
                Subscribe
            </div>

            <!-- Interval Selector Button Group -->
            <div class="float-right">
                <div class="flex gap-1" role="group" v-if="hasMonthlyAndYearlyPaidPlans">
                    <!-- Monthly Plans -->
                    <vx-button type="button"
                        @click="$emit('showMonthlyPlans')"
                        :outline="!showingMonthlyPlans"
                    >
                        Monthly
                    </vx-button>

                    <!-- Yearly Plans -->
                    <vx-button type="button"
                        @click="$emit('showYearlyPlans')"
                        :outline="!showingYearlyPlans"
                    >
                        Yearly
                    </vx-button>
                </div>
            </div>

            <div class="clearfix"></div>
        </div>

        <div class="table-responsive">
            <!-- Plan Error Message -->
            <div class="alert alert-danger m-4" v-if="form.errors.has('plan')">
                {{ form.errors.get('plan') }}
            </div>

            <table class="table table-responsive-sm table-valign-middle mb-0 ">
                <thead></thead>
                <tbody>
                    <tr v-for="(plan, index) in plansForActiveInterval" :key="index">
                        <!-- Plan Name -->
                        <td>
                            <div class="flex items-center">
                                <input type="radio"
                                       :checked="selectedPlan == plan"
                                       @click="selectPlan(plan)"
                                       class="mr-2 relative size-5 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-blue-600 checked:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
                                        :class="{invisible: form.busy}" />
                                {{ plan.name }}
                            </div>
                        </td>

                        <!-- Plan Price -->
                        <td>
                            <span class="table-plan-text">
                                <strong class="table-plan-price">{{ currency(plan.price) }}</strong>
                                {{ chargesTeamsPerSeat ? '/ '+ teamSeatName : '' }}
                                {{ chargesTeamsPerMember ? '/ '+ teams.member : '' }}
                                / {{ capitalize(plan.interval) }}
                            </span>
                        </td>

                        <!-- Trial Days -->
                        <td class="table-plan-price table-plane-text text-right">
                            <span v-if="plan.trialDays && !hasSubscribed(plan)">
                                {{ plan.trialDays }} Day Trial
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { currency, capitalize } from '../../../utils/helpers';
import { VxButton } from '@voxie/frontend-components';

export default {
    components: { VxButton },
    props: [
        'teams',
        'plans',
        'team',
        'form',
        'selectedPlan',
        'showingMonthlyPlans',
        'showingYearlyPlans',
    ],
    computed: {
        activeInterval() {
            return this.showingMonthlyPlans ? 'monthly' : 'yearly';
        },
        paidPlans() {
            return this.plans?.filter((plan) => {
                return plan.active && plan.price > 0;
            }) || [];
        },
        plansForActiveInterval() {
            return this.plans?.filter((plan) => {
                return plan.active && (plan.price === 0 || plan.interval === this.activeInterval);
            }) || [];
        },
        hasMonthlyAndYearlyPaidPlans() {
            return !!this.paidPlans.some((p) => p.interval === 'monthly') &&
                !!this.paidPlans.some((p) => p.interval === 'yearly')
        },
        chargesUsersPerSeat() {
            return Spark.chargesUsersPerSeat;
        },
        chargesTeamsPerSeat() {
            return Spark.chargesTeamsPerSeat;
        },
        chargesTeamsPerMember() {
            return Spark.chargesTeamsPerMember;
        },
        seatName() {
            return Spark.seatName;
        },
        teamSeatName() {
            return Spark.teamSeatName;
        },
    },
    methods: {
        currency,
        capitalize,
        selectPlan(plan) {
            this.$emit('plan-selected', plan);
        },
        hasSubscribed(plan) {
            return !!this.team.subscriptions?.filter((s) => s.provider_plan === plan.id).length;
        },
    },
};
</script>
